/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbShipping_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_shipment">;
    readonly " $refType": "PdpSharedBlurbShipping_shipment";
};
export type PdpSharedBlurbShipping_shipment$data = PdpSharedBlurbShipping_shipment;
export type PdpSharedBlurbShipping_shipment$key = {
    readonly " $data"?: PdpSharedBlurbShipping_shipment$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbShipping_shipment">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipment",
      "args": null
    }
  ]
};
(node as any).hash = 'fd943ebbb247a64b160488f7e7007c7b';
export default node;
